import { builder as Builder } from '@builder.io/react';
import { useQuery } from '@tanstack/react-query';
import { env } from '@/config/env';

const builder = Builder.init(env.NEXT_PUBLIC_BUILDER_IO_API_KEY);

// Builder.io content category ids were fetched with `await builder.getAll('blog-category', {})`
// @see https://www.builder.io/c/docs/content-api
const ABOUT = '15f4a6f5698e4842be236813a8913eae';
const AGENTS = '6a84549fed3742c3911bdf2d480a5baa';
const AUTO = '14e779401dcd41c0911996b3beef505a';
const BLOG = 'd18c67cd33f442cc899cbe7e14421d8a';
const CULTURE = 'bf5044e2220b49f0b20a4a0635cd29c5';
const INSURANCE = '057de120db4e45559002845b18e1d482';
const LEADERSHIP = '972853471eea4ef4accded20363b4e1a';
const RESOURCE = '05e90ef216834862bc1b4eb2a4f1d816';
const SAFETY = '3e5d6190674a41d99b5a85b328f82207';
const WORKERS = 'de800ee95281450cad33d1591861d2cb';

const CATEGORIES = {
  [ABOUT]: 'About-Pie-Insurance',
  [AGENTS]: 'For Agents',
  [AUTO]: 'Commercial Auto',
  [BLOG]: 'Blog',
  [CULTURE]: 'Culture',
  [INSURANCE]: 'Small Business Insurance',
  [LEADERSHIP]: 'Thought Leadership',
  [RESOURCE]: 'Small Business Resources',
  [SAFETY]: 'Safety',
  [WORKERS]: `Workers' Comp`,
};

// Also drives the number of loading skeletons rendered by RelatedArticles.
export const RECENT_ARTICLES_LIMIT = 6;

export const useRecentArticles = () =>
  useQuery({
    queryFn: async () => {
      const response = await builder.getAll('blog-detail', {
        fields: 'id,data',
        limit: RECENT_ARTICLES_LIMIT,
        options: { noTargeting: true },
        query: {
          'data.category.id': {
            $in: [INSURANCE, SAFETY, WORKERS],
          },
          published: { $eq: 'published' },
        },
        sort: {
          'data.publishedDate': -1,
        },
      });

      return response;
    },
    queryKey: ['builder.io', 'blog-detail'],
    select: (response) => {
      return response.map(({ data, id }) => {
        return {
          category: {
            id: data?.category.id,
            label: CATEGORIES[data?.category.id as keyof typeof CATEGORIES] ?? 'Unknown',
          },
          description: data?.description,
          id,
          readTime: data?.readTime ?? 0,
          title: data?.title,
          url: `https://pieinsurance.com${data?.url}`,
        };
      });
    },
    staleTime: 1000 * 60 * 60 * 12,
  });
